import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'connection-error',
  templateUrl: './connection-error.component.html',
  styleUrls: ['./connection-error.component.scss']
})
export class ConnectionErrorComponent {

  @Output()
  public retry: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }
}
